import { FC, useMemo } from 'react'
import { BackgroundType, PermissionsPageCustomization } from 'types/internal'

type Props = {
  avatarImageUrl?: string
  addDarkLayout?: boolean
  customization?: PermissionsPageCustomization
}

const Background: FC<Props> = ({
  avatarImageUrl,
  addDarkLayout,
  customization
}) => {
  const backgroundType = useMemo(() => {
    if (
      customization?.backgroundType === BackgroundType.AVATAR &&
      avatarImageUrl
    ) {
      return BackgroundType.AVATAR
    }
  }, [customization, avatarImageUrl])

  const backgroundColor = useMemo(() => {
    if (customization?.backgroundColor) {
      return `bg-[${customization?.backgroundColor}]`
    } else {
      return 'bg-[#1F2937]'
    }
  }, [customization])

  const renderAvatar = () => {
    if (avatarImageUrl && backgroundType === BackgroundType.AVATAR) {
      return (
        <>
          <img
            src={avatarImageUrl}
            alt='Avatar'
            className='absolute w-full h-full object-cover left-0 top-0 right-0 bottom-0'
          />
          {addDarkLayout && (
            <div className='absolute inset-0 bg-black bg-opacity-40' />
          )}
        </>
      )
    }
  }
  return (
    <div
      className={`absolute top-0 left-0 bottom-0 right-0 w-full h-full flex items-center justify-center ${backgroundColor}`}
    >
      {renderAvatar()}
    </div>
  )
}

export default Background
